const GRID_COLUMNS = 24;
export default GRID_COLUMNS;